import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["data-cms-width", "data-cms-height"]
const _hoisted_3 = ["src", "alt"]

import Debug from "debug";
import { computed, ref } from "vue";
import { VueFreezeframe } from "vue-freezeframe";
import { CmsImage } from "../../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-img',
  props: {
    src: { default: undefined },
    width: { default: undefined },
    height: { default: undefined },
    alt: { default: undefined },
    supportAnimation: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const debug = Debug("cs.CmsImg");

const props = __props;

const video = ref<HTMLVideoElement | null>(null);

const src$ = computed(() => {
  if (typeof props.src === "object") {
    return props.src.url;
  }

  return props.src;
});

const isAnimatedGif = computed((): boolean => {
  if (!props.supportAnimation || !src$.value) {
    return false;
  }

  const imageUrl = new URL(src$.value);
  return imageUrl.pathname.toLowerCase().endsWith(".gif");
});

const isVideo = computed((): boolean => {
  return (
    typeof props.src === "string" && (props.src.endsWith(".mp4") || props.src.endsWith(".avi"))
  );
});

const cmsWidth = computed(() => {
  if (typeof props.src === "object" && props.src.dimensions) {
    return props.src.dimensions.width;
  }

  return undefined;
});

const cmsHeight = computed(() => {
  if (typeof props.src === "object" && props.src.dimensions) {
    return props.src.dimensions.height;
  }

  return undefined;
});

const style$ = computed(() => ({
  "background-image": isAnimatedGif.value ? "" : `url("${src$.value}")`,
}));

const spacerStyle = computed(() => ({
  "padding-top": `${(100 * (cmsHeight.value || 0)) / (cmsWidth.value || 1)}%`,
  "max-height": "100%",
}));

const alt$ = computed(() => {
  if (props.alt) {
    return props.alt;
  }

  if (typeof props.src === "object" && props.src.alt) {
    return props.src.alt;
  }

  return "";
});

const animate = (resetOnEnter = false) => {
  if (isVideo.value) {
    if (resetOnEnter && video.value) {
      video.value.currentTime = 0;
    }
    if (video.value) video.value.play();
  }
};

const playAnimation = (areReversing: boolean) => {
  if (isAnimatedGif.value && ref<VueFreezeframe>("freezeframe")) {
    const freezeframe = ref<VueFreezeframe>("freezeframe");
    if (!areReversing && freezeframe.value) {
      debug("Playing animation", freezeframe);
      freezeframe.value.start();
    } else {
      debug("Not playing animation");
    }
  }
};

__expose({
  animate,
  playAnimation,
});

return (_ctx: any,_cache: any) => {
  return (isVideo.value)
    ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        style: _normalizeStyle(spacerStyle.value),
        ref_key: "video",
        ref: video,
        muted: "muted"
      }, [
        _createElementVNode("source", { src: src$.value }, null, 8, _hoisted_1)
      ], 4))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "cms-img",
        "data-cms-width": cmsWidth.value,
        "data-cms-height": cmsHeight.value,
        style: _normalizeStyle(style$.value)
      }, [
        _createElementVNode("div", {
          class: "cms-img-spacer",
          src: src$.value,
          style: _normalizeStyle(spacerStyle.value),
          alt: alt$.value
        }, null, 12, _hoisted_3)
      ], 12, _hoisted_2))
}
}

})